import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BookingStatus } from '@contact/upgrade';

import { AgentBookingSocialNetworkInprocessForwardComponent } from './inprocess-forward/agent-booking-social-network-inprocess-forward.component';
import { AgentBookingSocialNetworkInprocessComponent } from './inprocess/agent-booking-social-network-inprocess.component';
import { AgentBookingSocialNetworkQualificationComponent } from './qualification/agent-booking-social-network-qualification.component';

export enum AgentBookinSocialNetworkInprocessState {
  conversation = 'conversation',
  forward = 'forward',
}

const routes: Routes = [
  {
    path: BookingStatus.IN_PROCESS.toLowerCase(),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AgentBookinSocialNetworkInprocessState.conversation,
      },
      {
        path: AgentBookinSocialNetworkInprocessState.conversation,
        component: AgentBookingSocialNetworkInprocessComponent,
      },
      {
        path: `${AgentBookinSocialNetworkInprocessState.forward}/:${AgentDesktopRouteParams.IsConf.key}`,
        component: AgentBookingSocialNetworkInprocessForwardComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: BookingStatus.POST_PROCESSING.toLowerCase(),
    component: AgentBookingSocialNetworkQualificationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentBookingSocialNetworkRoutingModule {}
